"use strict";
import {on, findIn, removeAttribute} from "@elements/dom-utils";
import axios from "axios";
import {unCompleteTab, switchTab} from "../tabManager";
import TerracePlanner from "../index";

let backendUrl = window.location.protocol + '//' + window.location.hostname + '/r/terraceplanner/summary/';

export function init() {
    let range = findIn('.js-planner__excess-quantity', TerracePlanner.element)

    if (range) {
        if (range.getAttribute('data-target')) {
            setRangeBubble(range, findIn(range.getAttribute('data-target'), TerracePlanner.element));
        }

        on('click', () => {
            recalculateListener(range);
        }, findIn('.js-planner__excess-quantity-submit', TerracePlanner.element));

        on('change', () => {
            removeAttribute('disabled', findIn('.js-planner__excess-quantity-submit', TerracePlanner.element));
        }, range);

        on('input', () => {
            setRangeBubble(range, findIn(range.getAttribute('data-target'), TerracePlanner.element));
        }, range);
    }
}

function setRangeBubble(range, bubble) {
    let val = range.value;
    let min = range.min ? range.min : 0;
    let max = range.max ? range.max : 100;

    let newVal = Number(((val - min) * 100) / (max - min));

    // leave undefined to use the visitor's browser
    bubble.innerHTML = Number(val).toLocaleString(undefined, { minimumFractionDigits: 1 }) + '%';

    // bubble.style.left = Number(((val - min) * 100) / (max - min)) + "%";
    bubble.style.left = `calc(${newVal}% + (${8 - newVal * 0.15}px))`;
}

/**
 * updates the session based Terrace with a new excessQuantityPercentage and reloads the summary tab
 *
 */
export function recalculateListener (rangeItem) {
    console.log('call recalculateListener')
    axios({
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        url: backendUrl + 'excessQuantity',
        responseType: 'json',
        data: {
            excessQuantityPercentage: rangeItem.value
        }
    }).then(({success, data}) => {
        unCompleteTab('summary');
        switchTab('summary');
    });
}

// var terracePlannerExcessQuantity = (function ($, backendUrl, excessQuantityNode, initialExcessQuantity, recalculateButton) {
//
//     /**
//      * updates the session based Terrace with a new excessQuantityPercentage and reloads the summary tab
//      *
//      * @param event
//      */
//     var recalculateListener = function (event) {
//         var excessQuantityPercentage = excessQuantityNode.val();
//
//         $.ajax(backendUrl + 'excessQuantity', {
//             method: 'POST',
//             data: {excessQuantityPercentage: excessQuantityPercentage},
//             success: function (data) {
//                 terracePlannerTabManager.unCompleteTab('summary');
//                 terracePlannerTabManager.switchTab('summary');
//             }
//         });
//     };
//
//     /**
//      * uses the newly set percentage hide or show a recalculate button that triggers a new calculation
//      *
//      * @param values Array
//      * @param handle Number
//      * @param unEncoded Array
//      */
//     var sliderUpdateListener = function (values, handle, unEncoded) {
//         var newValue = Number(unEncoded[0].toFixed(1));
//         excessQuantityNode.attr('value', newValue);
//
//         if(initialExcessQuantity !== newValue) {
//             recalculateButton.removeClass('scale-out');
//         } else {
//             recalculateButton.addClass('scale-out');
//         }
//     };
//
//     /**
//      * initializes module vars and binds event listeners
//      */
//     var init = function () {
//         excessQuantityNode = $('#excessQuantity');
//         initialExcessQuantity = excessQuantityNode.data('initial-value');
//         recalculateButton = $('#recalculateButton');
//
//         terracePlannerNoUiSlider.getExcessQuantity().noUiSlider.on('update', sliderUpdateListener);
//         recalculateButton.click(recalculateListener);
//     };
//
//     return {
//         init: init
//     };
// })(jQuery, window.location.protocol + '//' + window.location.hostname + '/terraceplanner/summary/');